export enum NotificationType {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS ='success',
  WARNING = 'warning'
}
